exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".calc-headline-height{font-size:.875rem;position:absolute;visibility:hidden;height:auto;width:calc(9rem - 2px);word-break:break-word;line-height:1;font-weight:400}", ""]);

// exports
